<template>
    <ul class="m-pagination" v-if="pageNumbers > 0">
        <li v-for="page in pageNumbers" class="m-pagination__item"
            :class="[ page == (pageNo + 1) ? 'm-pagination__item--active' : '']">
            <a href="#" @click.prevent="changePage(page - 1)">
                {{ page }}
            </a>
        </li>
    </ul>
</template>

<script>
    export default {
        name:'paginator',
        props: {
            pageNumbers:{
                required:true
            },
            pageNo: {
                type:Number,
                required:true
            }
        },
        methods: {
            changePage(page) {
                this.$emit('change', page);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Paginator.vue?ee9ad250